// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Footer-components-FinePrint----fine-print-module---container---3QTw9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/components/FinePrint/fine-print.module.less
// module id = 259
// module chunks = 114276838955818